import {environment} from '../../../environments/environment';

export interface AppSection {
  id: number;
  name_es: string;
  name_en: string;
  name_fr: string;
  image: string;
  logo: string;
  url_es: string;
  url_en: string;
  url_fr: string;
  environment_id: number;
}

export interface Home {
  has_pois: boolean,
  has_how_works: boolean,
  has_house_rules: boolean,
  has_welcome: boolean,
  has_recommendations: boolean
}

export interface EnvironmentContact {
  contact: string | null;
  phone: string | null;
  email: string | null;
  whatsapp: string | null;
  web: string | null;
}

export interface ApartmentData {
  id: number;
  name: string;
  street: string;
  number: string;
  stairs: string | null;
  floor: string;
  door: string;
  city: string;
  country: string;
  postcode: string;
  notes: string | null;
  name_environment: string | null;
  id_environment: number | null;
  environment_image: string;
  environment_logo: string;
  environment_color: string;
  environment_contact: EnvironmentContact;
  id_apartment_pms: string;
  long: string;
  lat: string;
  owner: string;
  portal_message: string;
  doorbell_message: string;
  portal_door_message: string;
  landing_door_message: string;
  main_door_message: string;
  auxiliar_door2_message: string;
  auxiliar_door3_message: string;
  auxiliar_door4_message: string;
  bell: number;
  has_check_in: number;
  has_payment: number;
  has_opendoor: number;
  welcome_picture: string | null;
  welcome_video: string;
  welcome_text: string;
  url_plans_es: string | null;
  url_plans_en: string | null;
  url_plans_fr: string | null;
  active: number;
  intercom: number;
  tz_offset: string | null;
  open_door_system: string;
  has_landing_door: boolean;
  has_main_door: boolean;
  has_portal_door: boolean;
  has_aux_door2: boolean;
  has_aux_door3: boolean;
  has_aux_door4: boolean;
  push_portal_first: number;
  app_sections: AppSection[];
  home: Home;
}

export interface Apartment {
  data: ApartmentData;
}

function getDoorbelllMessageByLanguage(apartment: Apartment, lang: string): string | null {
  if (apartment.data.doorbell_message) {
    try {
      return JSON.parse(apartment.data.doorbell_message)[lang];
    } catch (e) {
    }
  }
  return null;
}


function buildDoorbellMessageErrorByLanguage(apartment: Apartment, lang: string): string {
  let portalMessage = getDoorbelllMessageByLanguage(apartment, lang);
  if (null === portalMessage) {
    portalMessage = JSON.parse(apartment.data.portal_message)[lang];
    const bell = apartment.data.bell == 1 ? '🔔' : '';
    portalMessage = 'No has pulsado el ' + portalMessage + ' ' + bell + ' para poder abrir el portal';
  }
  return portalMessage;
}

function buildDoorbellMessageBeforeByLanguage(apartment: Apartment, lang: string): string {
  let portalMessage = getDoorbelllMessageByLanguage(apartment, lang);
  if (null === portalMessage) {
    portalMessage = JSON.parse(apartment.data.portal_message)[lang];
    const bell = apartment.data.bell == 1 ? '🔔' : '';
    portalMessage = 'Para abrir la puerta del portal, primero pulsa ' + portalMessage + ' ' + bell + ' en el portero automático y después desliza para abrir en la app.';
  }
  return portalMessage;
}

function buildDoorbellMessageDuringByLanguage(apartment: Apartment, lang: string): string {
  let portalMessage = getDoorbelllMessageByLanguage(apartment, lang);
  if (null === portalMessage) {
    portalMessage = JSON.parse(apartment.data.portal_message)[lang];
    const bell = apartment.data.bell == 1 ? '🔔' : '';
    portalMessage = 'Por favor, pulsa ' + portalMessage + ' ' + bell + ' en el portero automático para abrir la puerta del portal. ¡Gracias!';
  }
  return portalMessage;
}

export function hasOpenDoor(apartment: Apartment): boolean {
  return apartment.data.has_opendoor === 1;
}

export function buildDoorbellMessageError(apartment: Apartment): string {
  return buildDoorbellMessageErrorByLanguage(apartment, environment.defaultAppLang);
}

export function buildDoorbellMessageDuring(apartment: Apartment): string {
  return buildDoorbellMessageDuringByLanguage(apartment, environment.defaultAppLang);
}

export function buildDoorbellMessageBefore(apartment: Apartment): string {
  return buildDoorbellMessageBeforeByLanguage(apartment, environment.defaultAppLang);
}
